import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { Button } from "react-bootstrap";

import { BREAKPOINT } from "utils/styles";
import {
  collapseAnimationDuration,
  collapseAnimationEasing,
} from "components/Feed/styles";

const Wrapper = styled.div`
  position: fixed;
  width: 40vw;
  padding: 0 3rem;
  bottom: ${({ isCollapsed }) => {
    return isCollapsed ? "-4rem" : "1rem";
  }};
  left: 0;
  text-align: center;
  transition: all ${collapseAnimationDuration} ${collapseAnimationEasing};
  z-index: 1;

  @media ${BREAKPOINT.M} {
    width: 100vw;
    padding: 0 5vw;
  }

  .btn:focus {
    color: inherit;
    background-color: #fff;
    border-color: transparent;
    box-shadow: none;
  }
  .btn:focus-visible {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
    box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
  }
`;

const Content = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;
  border-radius: 25px;
  padding: 0.625rem 0;
  box-shadow: 0 1.5px 2px rgba(0, 0, 0, 0.15);

  @media ${BREAKPOINT.M} {
    display: flex;
  }
`;

const PagerButton = styled(Button)`
  background: #fff;
  border-radius: 15px;
  line-height: 1.2;
  padding: 0.5rem 1rem 0.75rem 1rem;
  margin: 0 0.625rem;

  i {
    transform: translateY(0.25rem);
  }
`;
const Page = styled.div`
  padding: 0 1rem;
  i {
    transform: rotate(180deg) translatex(6px) translateY(-0.1875rem);
  }

  @media ${BREAKPOINT.M} {
    flex-grow: 1;
  }
`;

export default function Pager({
  nextDisabled,
  previousDisabled,
  next,
  previous,
  total,
  current,
  isCollapsed,
}) {
  return (
    <Wrapper isCollapsed={isCollapsed}>
      <Content>
        <PagerButton
          variant="light"
          disabled={previousDisabled}
          onClick={previous}
        >
          <i className="material-icons-round md-dark md-18">arrow_back</i>
        </PagerButton>
        <Page>
          <i className="material-icons-round md-dark md-18">wb_incandescent</i>{" "}
          {current} / {total}
        </Page>
        <PagerButton variant="light" disabled={nextDisabled} onClick={next}>
          Next{" "}
          <i className="material-icons-round md-dark md-18">arrow_forward</i>
        </PagerButton>
      </Content>
    </Wrapper>
  );
}
